// English strings for the console batch 3 (SYSTEM-001 / THEME-001, owner 2026-10-25; D-067): switches
// (kill switches, gradual rollout), health (services, incidents, integrations), storefronts and
// domains, the theme catalog, one shop's integrations, and what a shop sees when Adyvance pauses
// something. Spread into `en` as `en.platformOps`, so keys read `t("platformOps.…")`.
export const platformOpsStrings = {
  nav: { storefronts: "Storefronts", themes: "Theme catalog" },
  sections: {
    storefronts: "Every store, its domains and SSL, and its live theme.",
    themes: "The themes shops can use, premium prices and themes given to shops.",
  },
  switches: {
    lead: "Turn a feature or an operation off for everyone, a plan, some shops, or roll it out to a share of shops. It applies within seconds; shops see “paused”.",
    title: "Switches",
    operations: "Platform operations",
    ops: {
      signups: {
        name: "New shops can sign up",
        help: "Turning it off stops new businesses from being created.",
      },
      plan_checkout: {
        name: "Shops can buy plans",
        help: "Plan purchases and renewals from the shop.",
      },
      wallet_topups: {
        name: "Shops can send wallet top-ups",
        help: "Top-up receipts sent from the shop.",
      },
      service_purchases: {
        name: "Shops can buy services",
        help: "root AI credits, premium themes and add-ons.",
      },
    },
    states: { on: "On", off: "Paused", partial: "Partly" },
    offShops: { one: "Off for {count} shop", other: "Off for {count} shops" },
    search: "Search switches",
    filters: { all: "All", changed: "Changed", paused: "Paused" },
    edit: "Change",
    pauseAll: "Pause for everyone",
    resume: "Turn back on",
    everyone: "For everyone",
    everyoneOn: "On",
    everyoneOff: "Paused",
    rollout: "Roll out to a share of shops",
    rolloutHelp: "The same shops stay in the share when you raise it.",
    rolloutPct: "Share of shops (%)",
    plans: "By plan",
    planDefault: "As above",
    planOn: "On",
    planOff: "Off",
    shops: "Single shops",
    shopsHelp: "A shop's own setting wins over everything above.",
    addShop: "Add a shop",
    pickShop: "Pick a shop",
    shopOn: "On",
    shopOff: "Off",
    remove: "Remove",
    note: "Why (only the console team sees it)",
    save: "Save switch",
    saved: "Switch saved",
    updated: "Changed {date}",
    paused: { one: "{count} switch is not fully on", other: "{count} switches are not fully on" },
    allOn: "Everything is on.",
  },
  health: {
    tabs: { services: "Services", incidents: "Incidents", integrations: "Integrations" },
    overall: {
      operational: "Everything is working",
      minor: "Something is not right",
      major: "A service is down",
    },
    checked: "Checked {time}",
    runChecks: "Check now",
    checksRun: "Checks done",
    services: {
      api: "Admin and API",
      storefront: "Storefronts",
      console: "Owner console",
      jobs: "Background jobs",
      coord: "Live coordination",
    },
    status: { up: "Up", down: "Down", unknown: "Not checked yet" },
    latency: "{ms} ms",
    uptime: "{pct}% in 30 days",
    incidents: {
      lead: "Incidents show on the public status page with their note.",
      new: "New incident",
      title: "What is wrong",
      impact: "Impact",
      impacts: { minor: "Minor", major: "Major" },
      note: "Public note",
      notePh: "What shops and shoppers should know…",
      create: "Open incident",
      created: "Incident opened",
      states: {
        investigating: "Investigating",
        identified: "Identified",
        monitoring: "Monitoring",
        resolved: "Resolved",
      },
      move: "Move to",
      updated: "Incident updated",
      none: "No incidents.",
      started: "Started {date}",
      resolvedAt: "Resolved {date}",
    },
    integrations: {
      lead: "What the platform database knows about every shop's connections. Payment methods and couriers are on each shop's page.",
      kinds: {
        marketplace: "Marketplace",
        channel: "Sampark channel",
        webhook: "Incoming webhooks",
        jobs: "Background jobs",
      },
      names: {
        daraz: "Daraz",
        messenger: "Facebook Messenger",
        instagram: "Instagram",
        whatsapp: "WhatsApp",
        tiktok: "TikTok",
        jobs: "Failed jobs",
        esewa: "eSewa",
        khalti: "Khalti",
        fonepay: "Fonepay",
        pathao: "Pathao",
        ncm: "Nepal Can Move",
      },
      connected: { one: "{count} connected", other: "{count} connected" },
      problems: { one: "{count} problem", other: "{count} problems" },
      ok: "No problems",
      problemsList: "Problems",
      sync_late: "Sync is late",
      expired: "Sign-in expired",
      error: "Error",
      rejected: "{count} rejected calls",
    },
  },
  storefronts: {
    lead: "Every store on Adyvance: status, domains with their SSL and checks, and the live theme.",
    statuses: {
      live: "Live",
      draft: "Draft",
      coming_soon: "Coming soon",
      password: "Password",
      suspended: "Paused",
    },
    filters: { all: "All stores", problems: "Domain problems", custom: "Own domain" },
    customDomains: "Own domains",
    domainProblems: "Domain problems",
    columns: {
      store: "Store",
      status: "Status",
      domains: "Domains",
      theme: "Live theme",
      created: "Created",
    },
    platformHost: "Adyvance address",
    canonical: "Main",
    ssl: "SSL {state}",
    verify: "Check {state}",
    noTheme: "Not published yet",
    open: "Open store",
    openShop: "Open shop",
    search: "Search store, shop or domain",
    none: "No stores match.",
  },
  themes: {
    title: "Themes",
    lead: "Choose the themes shops can use, set premium prices and give themes to shops. Upload your own theme as a .zip with its photos.",
    status: "Shops can use it",
    preview: "Preview theme",
    previewOf: "Preview {name}",
    previewTitle: "{name} preview",
    previewMode: "Preview mode",
    closePreview: "Close preview",
    device: "Preview on",
    devices: { desktop: "Computer", tablet: "Tablet", phone: "Phone" },
    sampleShop: "Your shop",
    hidden: "Hidden from shops",
    shown: "Shown to shops",
    retired: "Retired",
    price: "Premium price",
    free: "Free",
    pricePh: "Free",
    periods: { once: "Once", yearly: "A year" },
    periodLabel: "Charged",
    live: { one: "Live on {count} store", other: "Live on {count} stores" },
    licences: "Shops that have it",
    noLicences: "No shop has it yet.",
    bought: "Bought",
    given: "Given",
    until: "until {date}",
    forever: "no end",
    revoke: "Take back",
    revoked: "Theme taken back",
    give: "Give to a shop",
    giveShop: "Shop",
    giveDays: "For how many days",
    giveForever: "No end",
    giveDo: "Give",
    given_toast: "Theme given",
    save: "Save",
    saved: "Theme saved",
    version: "Version {version}",
    usageNote: "Live stores are counted from each store's next theme publish.",
    // D-091: themes the owner uploads.
    builtIn: "Comes with Adyvance",
    uploaded: "Uploaded",
    states: { draft: "Draft", published: "Live", retired: "Retired" },
    waiting: "Version {version} is a draft. Shops still get {live}.",
    publish: "Publish",
    publishVersion: "Publish {version}",
    published: "Theme published. Shops can pick it now.",
    retire: "Retire",
    retiredToast: "Theme retired. Shops can no longer pick it.",
    newVersion: "Upload new version",
    download: "Download",
    downloadSample: "Download a sample",
    downloaded: "Theme file downloaded",
    // D-093: the gallery, Manage, delete and restore.
    filterLabel: "Show",
    filters: {
      all: "All",
      built_in: "Built-in",
      uploaded: "Uploaded",
      drafts: "Drafts",
      deleted: "Deleted",
    },
    search: "Search themes",
    noMatch: "No themes match",
    noMatchBody: "Try another filter or search.",
    noDeleted: "No deleted themes",
    noDeletedBody: "A deleted built-in theme shows here, and you can restore it.",
    defaultChip: "Default",
    deletedChip: "Deleted",
    manage: "Manage",
    more: "More for {name}",
    who: "Who can use it",
    pricing: "Price",
    versionsTitle: "Versions",
    themeFile: "Theme file",
    delete: "Delete",
    defaultNoDelete: "Default theme — can't be deleted",
    restore: "Restore",
    restored: "Theme restored. Shops can see it again.",
    deleteDialog: {
      title: "Delete {name}?",
      uploaded: "The theme and its photos are removed for good. You can upload it again later.",
      builtIn: "The theme is hidden from shops. You can restore it from Deleted at any time.",
      moving: {
        one: "{count} store uses it and will move to Default, keeping its colours, logo and sections.",
        other:
          "{count} stores use it and will move to Default, keeping their colours, logo and sections.",
      },
      noStores: "No store uses it now.",
      confirm: "Delete theme",
      keep: "Keep theme",
    },
    deletedToast: {
      one: "Deleted · {count} store moved to Default",
      other: "Deleted · {count} stores moved to Default",
    },
    sample: {
      title: "Download a sample",
      help: "A starter kit (.zip) with theme.json, the theme's sample photos in images/ and a README. Pick the theme to start from, change it, then upload it.",
      startFrom: "Start from",
      download: "Download .zip",
      done: "Starter kit downloaded",
      failed: "The starter kit could not be made. Try again.",
      fonts: "{display} + {body}",
      readme:
        'Adyvance theme starter kit, made from {name}\n\nWhat is in this .zip\n- theme.json: the theme. Colours, page layout, fonts, header and footer settings and the home page sections. It never contains code.\n- images/: the photos the preview shows (PNG, JPEG or WebP).\n- README.txt: this file (it is not uploaded).\n\ntheme.json\n- format: always "adyvance.theme/1".\n- key: your theme\'s own id, 3 to 40 small letters, numbers or dashes, starting with a letter. A built-in theme\'s key cannot be used. Keep the same key for every new version.\n- name: up to 40 characters. summary: up to 160 characters.\n- version: like 1.0.0. Each new upload of the same key needs a higher number.\n- document.layout: one of {layouts}.\n- document.font: one of {fonts}. Leave it out to use the layout\'s own fonts.\n- document.theme_css: optional CSS for the theme, up to {cssMax} characters. No url(), image(), @import, backslashes or the < sign, and every opening brace needs a closing one.\n- document.tokens: the colours. primary and accent must be dark enough for text on white.\n- document.settings and document.home: the header and footer, and the home page sections.\n- Pictures from a shop\'s library (asset_id) are not allowed.\n\nThe preview block\nShown in the theme gallery and the theme preview, never installed in a shop.\n- preview.card: an optional card picture, for example "images/card.webp". Without one the card is drawn live.\n- preview.images: where each photo goes, as a path into the document. "home/0/settings/image": "images/hero.webp" puts hero.webp into the first home section\'s image.\n- preview.products: up to 12 sample products with title, price_paisa (Rs 1 = 100 paisa), compare_at_paisa and image.\n\nLimits\n- Up to {files} files in the .zip, each up to {fileMb} MB, {totalMb} MB in all.\n- theme.json sits at the top of the .zip, photos under images/. Photo names use small letters, numbers, dots, dashes and underscores.\n\nUpload\nOwner console > Theme catalog > Upload theme. It starts as a draft; publish it when you are ready.\n',
    },
    upload: {
      open: "Upload theme",
      looks: "How it looks",
      title: "Upload theme",
      titleVersion: "New version of {name}",
      help: "Upload a .zip with theme.json and its photos in images/, or a plain theme.json. A theme is colours, a page layout, fonts and sections. It never contains code.",
      file: "Theme file (.zip or .json)",
      drop: "Drop a .zip or .json file here",
      limits: ".zip up to {zipMb} MB · .json up to 1 MB",
      choose: "Choose a file",
      reading: "Reading the file…",
      checks: "Checks",
      check: {
        valid: "Theme file is valid",
        invalid: "Theme file has problems",
        photos: { one: "{count} photo found", other: "{count} photos found" },
        noPhotos: "No photos named (the preview uses sample photos)",
        missing: "Missing in the .zip: {files}",
        notImage: "Not a PNG, JPEG or WebP picture: {files}",
        jsonPhotos: "This file names photos. Upload it as a .zip with an images/ folder.",
        fonts: "Fonts: {display} + {body}",
        layoutFonts: "Fonts: the layout's own",
        css: "Theme CSS checked",
        noCss: "No theme CSS",
        card: "Card picture included",
        noCard: "No card picture (the card is drawn live)",
        cardChosen: "Card picture chosen",
        cardNeeded: "Choose a card picture below",
        newer: "Version {version} is newer than {current}",
        notNewer: "Version {version} is not newer than {current}",
        wrongKey: "This file is for “{key}”, not “{expected}”",
        okLabel: "Passed",
        badLabel: "Needs a fix",
        infoLabel: "Note",
      },
      products: "Sample products",
      productsCount: { one: "{count} product", other: "{count} products" },
      productsLayout: "The layout's samples",
      previewEmpty: "Choose a theme file to see it here, with its own photos.",
      size: "{size} KB",
      chooseFile: "Choose theme file",
      changeFile: "Choose another file",
      picture: "Card picture",
      pictureHelp: "PNG, JPEG or WebP, up to 500 KB. Shops see it in their theme gallery.",
      choosePicture: "Choose picture",
      changePicture: "Change picture",
      summary: "What is in the file",
      name: "Name",
      key: "Key",
      versionLabel: "Version",
      layout: "Page layout",
      colours: "Colours",
      sections: {
        one: "{count} section on the home page",
        other: "{count} sections on the home page",
      },
      newVersionOf: "This is a new version of {name} (now {version}).",
      problems: "Fix these in the file, then choose it again:",
      submit: "Upload as draft",
      done: "Theme uploaded as a draft. Publish it when you are ready.",
      cancel: "Cancel",
      failed: "The upload was refused:",
    },
    problems: {
      invalid_json: "The file is not a valid JSON file.",
      too_big: "The file is larger than 1 MB.",
      wrong_key: "This file is for the theme “{key}”, not “{expected}”.",
      reserved_key: "This key belongs to a theme that comes with Adyvance. Pick another key.",
      key: "The key must be 3 to 40 small letters, numbers or dashes, starting with a letter.",
      format: "This is not an Adyvance theme file. “format” must be “adyvance.theme/1”.",
      version: "The version must look like 1.0.0.",
      not_newer: "Give the new version a higher number than {version}.",
      name: "The name must be 1 to 40 characters.",
      layout: "The page layout must be one of: {layouts}.",
      contrast: "The {token} colour is too light for text on white. Pick a darker shade.",
      images_not_allowed:
        "A theme file cannot use pictures from a shop's library. Remove the logo and image entries.",
      unknown_field: "“{path}” is not part of a theme file.",
      other: "“{path}” is not valid.",
      picture_type: "The picture must be a PNG, JPEG or WebP file.",
      picture_too_large: "The picture is larger than 500 KB.",
      picture_format: "The picture could not be read.",
      // D-093: theme .zip packages.
      too_big_zip: "The .zip is larger than {mb} MB.",
      zip_not_zip: "The file is not a .zip file.",
      zip_unsupported:
        "This .zip uses something we can't read (a password or a very large .zip). Make it again with a normal zip tool.",
      zip_too_many: "The .zip has more than {files} files.",
      zip_too_large: "The .zip is too big: each file can be up to 1 MB and {mb} MB in all.",
      zip_corrupt: "The .zip is damaged. Make it again.",
      no_theme_json: "There is no theme.json at the top of the .zip.",
      nested_theme_json: "theme.json is inside a folder. Put it at the top of the .zip.",
      missing_file: "“{path}” is named in theme.json but is not in the .zip.",
      not_image: "“{path}” is not a PNG, JPEG or WebP picture.",
      file_too_large: "“{path}” is larger than 1 MB.",
    },
  },
  shopIntegrations: {
    tab: "Integrations",
    payments: "Payment methods",
    couriers: "Couriers",
    channels: "Sampark channels",
    marketplaces: "Marketplaces",
    none: "None set up.",
    enabled: "On",
    disabled: "Off",
    connected: "Connected",
    notConnected: "Not connected",
    states: {
      active: "Working",
      pending_activation: "Waiting for activation",
      error: "Error",
      connected: "Connected",
      expired: "Sign-in expired",
    },
    modes: { live: "Live", test: "Test" },
    providers: {
      cod: "Cash on delivery",
      manual_qr: "QR (manual)",
      fonepay_qr: "Fonepay QR",
      fonepay_web: "Fonepay",
      esewa: "eSewa",
      khalti: "Khalti",
      stripe: "Stripe (cards)",
    },
  },
  shop: {
    pausedBadge: "Paused",
    pausedTitle: "{feature} is paused for a moment",
    pausedBody:
      "Adyvance paused this while something is being fixed. Your data is safe; it comes back on its own. Try again a little later.",
    pausedHelp: "Ask our team",
  },
} as const;
